<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :selection="false"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      label-width="100px"
    />
  </div>
</template>

<script>
export default {
  name: 'Guanliyuanyonghu',
  components: {},
  data() {
    return {
      url: '/user/page',
      columns: [
        {
          label: '管理员账号',
          prop: 'loginName'
        },
        {
          label: '管理员姓名',
          prop: 'userName'
        },
        {
          label: '所属企业',
          prop: 'orgName'
        },
        {
          label: '角色',
          prop: 'roleNames'
        },
        {
          label: '手机号',
          prop: 'mobile'
        },
        {
          label: '状态',
          prop: 'frozen',
          template: function(index, reocrd) {
            return reocrd.frozen
              ? "<div class='circle red'></div><span>冻结</span>"
              : "<div class='circle green'></div><span>正常</span>"
          }
        }
      ],
      // 操作栏
      handles: {
        width: 260,
        btns: [
          {
            label: '修改',
            icon: 'el-icon-edit',
            permission: 'power.Administrator.update',
            handle: resp => {
              this.$router.push({ path: './reviseAdministrators', query: { data: resp }})
            }
          },
          {
            label: '密码重置',
            icon: 'el-icon-key',
            permission: 'power.Administrator.Reset',
            url: '/user/resetPwd',
            method: 'post',
            isConfirm: true,
            confirmText: '是否确定将密码重置为888888？',
            before: (index, record) => {
              const p = {
                id: record.id
              }
              return p
            },
            handle: resp => {
              this.$notify({
                title: '成功',
                message: '重置密码成功',
                type: 'success'
              })
            }
          },
          {
            label: '冻结',
            permission: 'power.Administrator.frozen',
            style: 'color:red',
            getLabel: function(record) {
              return record.frozen ? '恢复' : '冻结'
            },
            url: '/user/frozen',
            method: 'post',
            isConfirm: true,
            confirmText: '是否确定执行本操作？',
            before: function(index, record) {
              const p = {
                id: record.id
              }
              return p
            },
            handle: resp => {
              this.$refs.tableref.queryTable()
            }
          },
          {
            label: '删除',
            permission: 'power.Administrator.delete',
            style: 'color:red',
            isConfirm: true,
            url: '/user',
            method: 'delete',
            getLabelDisabled: record => {
              console.log(record)
              return record.canDelete == '1'
            },
            before: (index, record) => {
              const arr = []
              arr.push(record.id)
              return {
                ids: arr
              }
            },
            handle: resp => {
              this.$refs.tableref.queryTable()
            }
          }
        ]
      },
      query: [
        {
          label: '管理员账号',
          prop: 'loginName',
          placeholder: '请输入管理员账号'
        },
        {
          label: '管理员姓名',
          prop: 'userName',
          placeholder: '请输入管理员姓名'
        },
        {
          label: '手机号',
          prop: 'mobile',
          placeholder: '请输入手机号'
        },
        {
          label: '状态',
          prop: 'frozen',
          type: 'select',
          data: [
            {
              label: '正常',
              value: 'false'
            },
            {
              label: '冻结',
              value: 'true'
            }
          ]
        },
        {
          label: '所属企业',
          prop: 'orgName',
          placeholder: '请输入所属企业'
        }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'power.Administrator.add',
          type: 'primary',
          handle: resp => {
            this.$router.push('./addAdministrators')
          }
        }
      ]
    }
  },
  computed: {},
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped></style>



// WEBPACK FOOTER //
// src/views/userManagement/administrators.vue